import { createSelector, Petrus } from '../../dependencies';

const sentrySelector = state => state.sentry;

export const sentryEventIdSelector = createSelector(sentrySelector, sentry => sentry.eventId);

export const authUserSelector = createSelector(Petrus.entitiesSelector, entities => entities.user);
